import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { switchMap, map, catchError, of } from 'rxjs';
import { RecipientService } from '../services/recipient.service';
import {
  fetchRecipientList,
  loadedRecipientList,
  failedRecipientList,
  updateRecipientListFilter,
} from './recipient-list.actions';
import { selectRecipientListFilter } from './recipient-list.selector';

@Injectable()
export class RecipientListEffect {
  loadRecipientList$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(fetchRecipientList),
      switchMap(({ filter }) =>
        this.recipientService.getRecipientList(filter).pipe(
          map(res => {
            if (res.success) {
              return loadedRecipientList({
                dataSource: {
                  totalRecords: res.response.totalRecords,
                  page: res.response.page,
                  count: res.response.count,
                  rawData: res.response.list,
                },
              });
            } else {
              return failedRecipientList();
            }
          }),
          catchError(() => of(failedRecipientList()))
        )
      )
    );
  });

  updateFilter$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(updateRecipientListFilter),
      concatLatestFrom(() => this.store.select(selectRecipientListFilter)),
      switchMap(([action, prevFilter]) =>
        of(fetchRecipientList({ filter: { ...prevFilter, ...action.filter } }))
      )
    );
  });

  constructor(
    private store: Store,
    private readonly actions$: Actions,
    private readonly recipientService: RecipientService
  ) {}
}
